import React from "react";

type IconProps = {
    className?: string;
};

export const BookIcon = ({ className }: IconProps) => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <mask
                id="mask0_473_2014"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="48"
                height="48"
            >
                <rect width="48" height="48" fill="white" />
            </mask>
            <g mask="url(#mask0_473_2014)">
                <path
                    d="M25.2915 34.7083C26.6809 34.0139 28.0458 33.4931 29.3861 33.1458C30.7266 32.7986 32.1505 32.625 33.6578 32.625C34.7191 32.625 35.8123 32.7083 36.9373 32.875C38.0623 33.0417 39.0137 33.2639 39.7915 33.5417V15.6625C38.8471 15.1653 37.854 14.8194 36.8123 14.625C35.7707 14.4306 34.7191 14.3333 33.6578 14.3333C32.1505 14.3333 30.6918 14.5625 29.2815 15.0208C27.8715 15.4792 26.5415 16.1214 25.2915 16.9475V34.7083ZM24.1898 38.9583C23.9632 38.9583 23.728 38.9311 23.4844 38.8767C23.2408 38.8222 23.0098 38.7383 22.7915 38.625C21.5137 37.7917 20.1566 37.1528 18.7203 36.7083C17.2841 36.2639 15.8209 36.0417 14.3307 36.0417C13.3987 36.0417 12.4816 36.1729 11.5794 36.4354C10.6772 36.6979 9.77567 36.9694 8.87484 37.25C7.97623 37.7222 7.07109 37.7061 6.15942 37.2017C5.24748 36.6972 4.7915 35.88 4.7915 34.75V15.5962C4.7915 14.921 4.94428 14.2944 5.24984 13.7167C5.55539 13.1389 6.01373 12.6778 6.62484 12.3333C7.91317 11.875 9.17886 11.5174 10.4219 11.2604C11.6647 11.0035 12.9404 10.875 14.249 10.875C16.0082 10.875 17.7259 11.1181 19.4023 11.6042C21.0784 12.0903 22.6387 12.8472 24.0832 13.875C25.5276 12.875 27.0604 12.125 28.6815 11.625C30.3026 11.125 31.9928 10.875 33.7519 10.875C35.0641 10.875 36.3362 11.0208 37.5682 11.3125C38.8004 11.6042 40.0554 11.9444 41.3332 12.3333C41.9443 12.6778 42.4096 13.1389 42.729 13.7167C43.0485 14.2944 43.2082 14.9306 43.2082 15.625V35.2083C43.2082 36.2372 42.7454 36.9736 41.8198 37.4175C40.894 37.8614 39.9818 37.8056 39.0832 37.25C38.2101 36.9417 37.3254 36.6632 36.429 36.4146C35.5326 36.166 34.6194 36.0417 33.6894 36.0417C32.2164 36.0417 30.7957 36.2708 29.4273 36.7292C28.059 37.1875 26.7637 37.8194 25.5415 38.625C25.3534 38.7383 25.1379 38.8222 24.8948 38.8767C24.6518 38.9311 24.4168 38.9583 24.1898 38.9583Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
};
